import type { Video } from "@/types/video";
import { toDateValue } from "@/utils/format";

export interface VideoFilterState {
  category: string;
  tag: string;
  region: string;
  date: string;
  duration: string;
}

export const defaultFilter: VideoFilterState = {
  category: "all",
  tag: "all",
  region: "all",
  date: "all",
  duration: "all",
};

export const REGION_OPTIONS = ["全部", "中国大陆", "欧美", "日韩", "港台", "其他"];

export const DATE_OPTIONS = [
  { value: "all", label: "全部时间" },
  { value: "today", label: "今天" },
  { value: "week", label: "本周" },
  { value: "month", label: "本月" },
  { value: "year", label: "今年" },
];

export const DURATION_OPTIONS = [
  { value: "all", label: "全部时长" },
  { value: "lt60", label: "1分钟以下" },
  { value: "60-300", label: "1-5分钟" },
  { value: "300-600", label: "5-10分钟" },
  { value: "gt600", label: "10分钟以上" },
];

export const SORT_OPTIONS = [
  { value: "latest", label: "最新发布" },
  { value: "hot", label: "最多播放" },
  { value: "rating", label: "评分最高" },
];

function matchDate(iso: string, range: string): boolean {
  if (range === "all") return true;
  const diff = Math.floor((Date.now() - toDateValue(iso)) / 86400000);
  if (range === "today") return diff <= 0;
  if (range === "week") return diff < 7;
  if (range === "month") return diff < 30;
  if (range === "year") return diff < 365;
  return true;
}

function matchDuration(duration: number, range: string): boolean {
  if (range === "all") return true;
  if (range === "lt60") return duration < 60;
  if (range === "60-300") return duration >= 60 && duration < 300;
  if (range === "300-600") return duration >= 300 && duration < 600;
  if (range === "gt600") return duration >= 600;
  return true;
}

export function applyFilters(list: Video[], filter: VideoFilterState): Video[] {
  return list.filter((video) => {
    if (filter.category !== "all" && video.category !== filter.category) return false;
    if (filter.tag !== "all" && !video.tags.includes(filter.tag)) return false;
    if (filter.region !== "all" && video.region !== filter.region) return false;
    if (!matchDate(video.uploadDate, filter.date)) return false;
    if (!matchDuration(video.duration, filter.duration)) return false;
    return true;
  });
}

export function sortVideos(list: Video[], sort: string): Video[] {
  const copy = [...list];
  if (sort === "hot") {
    return copy.sort((a, b) => b.views - a.views);
  }
  if (sort === "rating") {
    return copy.sort((a, b) => b.rating - a.rating);
  }
  return copy.sort((a, b) => toDateValue(b.uploadDate) - toDateValue(a.uploadDate));
}